var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.77115 1.12188C4.45201 1.26406 4.2552 1.45703 4.11158 1.76172C4.0052 1.99023 3.99988 2.02578 3.99988 14V26.0098L4.12754 26.2637C4.27647 26.5684 4.4786 26.7563 4.79775 26.8934C5.03711 26.9949 5.09562 27 13.9999 27C22.9041 27 22.9626 26.9949 23.202 26.8934C23.5212 26.7563 23.7233 26.5684 23.8722 26.2637L23.9999 26.0098V15.7773V5.55L21.6169 3.275L19.2392 1H12.1382H5.03711L4.77115 1.12188ZM18.5212 3.54922C18.5212 5.15899 18.5265 5.19453 18.6488 5.44336C18.7126 5.58047 18.8669 5.78359 18.9892 5.88516C19.3616 6.20508 19.5424 6.23047 21.4041 6.23047H23.0424V16.0312V25.8371L22.9095 25.959L22.7818 26.0859H13.9999H5.21796L5.0903 25.959L4.95732 25.8371V14V2.16289L5.0903 2.04102L5.21796 1.91406H11.8722H18.5212V3.54922ZM21.9946 5.30625C21.7924 5.31641 21.2073 5.31641 20.6914 5.30625C19.7818 5.29102 19.7499 5.28594 19.6169 5.16914L19.4786 5.04727V3.79805V2.54883L20.9148 3.91992L22.3509 5.29102L21.9946 5.30625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.95728 8.48506C7.64877 8.62217 7.31898 8.9624 7.24452 9.22139C7.15941 9.51084 7.18069 9.98819 7.29239 10.2167C7.76047 11.2069 9.27643 11.2323 9.77643 10.2624C9.95196 9.92217 9.97324 9.48037 9.8243 9.13506C9.7126 8.871 9.27643 8.48506 9.01047 8.41397C8.67005 8.32764 8.25516 8.35303 7.95728 8.48506ZM8.8243 9.38897C9.03707 9.60733 8.98388 9.90694 8.72324 10.0136C8.43069 10.1304 8.15409 9.95772 8.14877 9.66319C8.14877 9.32803 8.59026 9.1503 8.8243 9.38897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7126 9.68359V10.1406H16.2605H20.8084V9.68359V9.22656H16.2605H11.7126V9.68359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.06911 12.7558C6.8723 13.1824 6.90422 14.8683 8.11698 15.2492C8.63294 15.4117 9.234 15.2644 9.58507 14.8836C9.82975 14.6144 9.92017 14.3808 9.92017 14C9.92017 13.2535 9.40422 12.7355 8.62762 12.7C8.40954 12.6898 8.20209 12.7101 8.06911 12.7558ZM8.80847 13.7004C8.91486 13.7816 8.94677 13.8476 8.94677 14C8.94677 14.2234 8.7606 14.4062 8.5372 14.4062C8.35634 14.4062 8.1489 14.1929 8.1489 14C8.1489 13.807 8.35634 13.5937 8.5372 13.5937C8.60634 13.5937 8.72869 13.6394 8.80847 13.7004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.7126 14V14.457H16.2605H20.8084V14V13.543H16.2605H11.7126V14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.23928 17.052C7.60098 17.1941 7.19673 17.6766 7.19141 18.291C7.19141 18.7074 7.26587 18.9207 7.4946 19.1797C7.74992 19.4641 8.13821 19.6367 8.52119 19.6367C8.95204 19.6367 9.17545 19.5605 9.468 19.3066C9.78715 19.0324 9.91481 18.7582 9.92013 18.3367C9.92545 17.7324 9.54779 17.2449 8.93077 17.0723C8.6329 16.9859 8.53715 16.9859 8.23928 17.052ZM8.92013 18.1793C8.99992 18.357 8.97864 18.4434 8.82439 18.6059C8.59566 18.8496 8.14885 18.6719 8.14885 18.3469C8.15417 17.9152 8.74992 17.7883 8.92013 18.1793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.7126 18.3164V18.7734H16.2605H20.8084V18.3164V17.8594H16.2605H11.7126V18.3164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.95728 21.4851C7.64877 21.6222 7.31898 21.9624 7.24452 22.2214C7.15941 22.5108 7.18069 22.9882 7.29239 23.2167C7.76047 24.2069 9.27643 24.2323 9.77643 23.2624C9.95196 22.9222 9.97324 22.4804 9.8243 22.1351C9.7126 21.871 9.27643 21.4851 9.01047 21.414C8.67005 21.3276 8.25516 21.353 7.95728 21.4851ZM8.8243 22.389C9.03707 22.6073 8.98388 22.9069 8.72324 23.0136C8.43069 23.1304 8.15409 22.9577 8.14877 22.6632C8.14877 22.328 8.59026 22.1503 8.8243 22.389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.7126 22.6836V23.1406H16.2605H20.8084V22.6836V22.2266H16.2605H11.7126V22.6836Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksMobile);
export default __webpack_public_path__ + "static/media/tasksMobile.6ae558096ce06a9095aa5dab501758f5.svg";
export { ForwardRef as ReactComponent };